'use client';

import type { CalendarEventDraft } from './types';

type Props = {
  draft: CalendarEventDraft;
  readOnly: boolean;
  suggestMode?: boolean;
  onChange: (draft: CalendarEventDraft) => void;
};

export function CalendarEventForm({ draft, readOnly, suggestMode = false, onChange }: Props) {
  function set<K extends keyof CalendarEventDraft>(key: K, value: CalendarEventDraft[K]) {
    onChange({ ...draft, [key]: value });
  }

  return (
    <div className="calendar-event-form">
      <label>
        Title
        <input
          type="text"
          value={draft.title}
          readOnly={readOnly}
          required
          onChange={(e) => set('title', e.target.value)}
        />
      </label>
      <label className="calendar-event-form__checkbox">
        <input
          type="checkbox"
          checked={draft.allDay}
          disabled={readOnly}
          onChange={(e) => set('allDay', e.target.checked)}
        />
        All day
      </label>
      <div className="calendar-event-form__row">
        <label>
          Start date
          <input
            type="date"
            value={draft.startDate}
            readOnly={readOnly}
            onChange={(e) => set('startDate', e.target.value)}
          />
        </label>
        {!draft.allDay && (
          <label>
            Start time
            <input
              type="time"
              value={draft.startTime}
              readOnly={readOnly}
              onChange={(e) => set('startTime', e.target.value)}
            />
          </label>
        )}
      </div>
      <div className="calendar-event-form__row">
        <label>
          End date
          <input
            type="date"
            value={draft.endDate}
            readOnly={readOnly}
            onChange={(e) => set('endDate', e.target.value)}
          />
        </label>
        {!draft.allDay && (
          <label>
            End time
            <input
              type="time"
              value={draft.endTime}
              readOnly={readOnly}
              onChange={(e) => set('endTime', e.target.value)}
            />
          </label>
        )}
      </div>
      <label>
        Location{suggestMode ? ' (optional)' : ''}
        <input
          type="text"
          value={draft.location}
          readOnly={readOnly}
          onChange={(e) => set('location', e.target.value)}
        />
      </label>
      <label>
        Event link{suggestMode ? ' (optional)' : ''}
        <input
          type="url"
          value={draft.url}
          readOnly={readOnly}
          placeholder={suggestMode ? 'https://…' : undefined}
          onChange={(e) => set('url', e.target.value)}
        />
      </label>
      <label>
        Description{suggestMode ? ' (optional)' : ''}
        <textarea
          rows={4}
          value={draft.description}
          readOnly={readOnly}
          onChange={(e) => set('description', e.target.value)}
        />
      </label>
    </div>
  );
}
